function waitForShipProtectButton() {
  const cartHasOnlyKeepsakeDownload = () => {
    const cartDrawer = document.querySelector("kaching-cart-drawer");
    const cartItems = cartDrawer
      ? cartDrawer.querySelectorAll(".kaching-cart-item-container > .kaching-cart-item")
      : [];

    if (cartItems.length !== 1) {
      return false;
    }

    const item = cartItems[0];
    const titleLink = item.querySelector(".kaching-cart-item__title");
    const title = titleLink ? titleLink.textContent.trim() : "";
    const handle = item.dataset.productHandle || "";
    const requiresShipping = item.dataset.requiresShipping === "true";

    return (
      !requiresShipping &&
      title === "Keepsake Portrait Download" &&
      handle.startsWith("keepsake-portrait-download")
    );
  };

  waitForElm(".monster-protection input").then(() => {
    try {
      const inputDiv = document.querySelector(".monster-protection .react-switch-bg");
      const input = document.querySelector(".monster-protection input");
      const checked = input.getAttribute('aria-checked') == "true";
      // const cartContainer = document.querySelector("#mu-items-container");
      // const cartItems = cartContainer ? cartContainer.querySelectorAll(".mu-cart-item") : [];
      // const shouldDisableForKeepsake =
      //   cartItems.length === 1 &&
      //   (() => {
      //     const titleLink = cartItems[0].querySelector(".mu-item-title a");
      //     return titleLink && titleLink.textContent.trim() === "Keepsake Portrait Download";
      //   })();

      // if (shouldDisableForKeepsake) {
      //   if (checked) {
      //     inputDiv && inputDiv.click();
      //   }
      //   return;
      // }

      if (!checked) {
        inputDiv.click();
      }
    } catch (error) {
      console.log(error);
    }
  });

  waitForElm(".kaching-upsell-toggle-item__toggle-container .kaching-cart-toggle").then((elm) => {
    try {
      const isActive = elm.classList.contains("kaching-cart-toggle__active");

      if (cartHasOnlyKeepsakeDownload()) {
        if (isActive) {
          elm.click();
        }

        return;
      }

      if (!isActive) {
        elm.click();
      }
    } catch (error) {
      console.log(error);
    }
  });
}
